import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import Wrap from './sections/Wrap';
import useStores from '../../utils/useStores';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MuiGrid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Welcome from '../WelcomeAfterLogin';

const useStyles = makeStyles(theme => ({
  textfield: {
    marginBottom: theme.spacing(4),
  },
}));

const Input = props => {
  const classes = useStyles();
  return (
    <TextField
      className={classes.textfield}
      InputLabelProps={{ shrink: true }}
      variant="outlined"
      {...props}
    />
  );
};

const Login = props => {
  const { getInitialProps, afterSubmit } = props;
  const { loginStore } = useStores();
  const [formState, setFormState] = React.useState({ email: '', password: '' });
  const [status, setStatus] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const handleChangeValue = key => e => {
    setFormState({
      ...formState,
      [key]: e.target.value,
    });
  };

  const handleSubmit = e => {
    e.preventDefault();
    const { email, password } = formState;
    setStatus(null);
    setIsLoading(true);
    loginStore.loginAsync(email, password).then(res => {
      setIsLoading(false);
      if (res.status === 200) {
        setIsLoading(false);
        getInitialProps && getInitialProps();
      } else {
        setStatus('error');
        // console.warn('error trying login', res);
      }
      afterSubmit && afterSubmit();
    });
  };

  const handleLogout = () => {
    loginStore.logoutAsync();
  };

  return (
    <Wrap>
      <Box mb={8}>
        <Typography variant="h2" align="center">
          Anmeldung
        </Typography>
      </Box>
      {!loginStore.isLoggedIn && (
        <React.Fragment>
          <Box mb={8}>
            <Typography variant="h6">Sie sind DEPV-Mitglied?</Typography>
            <Typography variant="h6">
              Loggen Sie sich hier ein und genießen Sie erweiterten Zugriff auf
              News, Informationen und Downloads.
            </Typography>
          </Box>
          <MuiGrid container spacing={2}>
            <MuiGrid item xs={12} sm={12} md={6}>
              <Box
                component="form"
                display="flex"
                flexDirection="column"
                onSubmit={handleSubmit}
              >
                <Input
                  value={formState.email}
                  label="E-Mail"
                  id="email"
                  type="email"
                  required
                  onChange={handleChangeValue('email')}
                />
                <Input
                  value={formState.password}
                  label="Passwort"
                  id="password"
                  type="password"
                  required
                  onChange={handleChangeValue('password')}
                  helperText={
                    <Typography
                      variant="body2"
                      component="a"
                      color="primary"
                      href="/de/forgot-password"
                      target="_blank"
                    >
                      Passwort vergessen?
                    </Typography>
                  }
                />
                <Button type="submit" disabled={isLoading}>
                  {isLoading ? <CircularProgress size={20} /> : 'Anmelden'}
                </Button>
                {status === 'error' && (
                  <Box mt={2}>
                    <Typography color="error" variant="body2">
                      E-Mail-Adresse und/oder Passwort falsch. Bitte versuchen
                      sie es erneut.
                    </Typography>
                  </Box>
                )}
              </Box>
            </MuiGrid>
            <MuiGrid item xs={12} sm={12} md={6}>
              <Box display="flex" justifyContent="space-around">
                <img src="/images/DEPV_Logo.svg" alt="Fachstudio Logo" />
              </Box>
            </MuiGrid>
          </MuiGrid>
        </React.Fragment>
      )}
      {loginStore.isLoggedIn && (
        <React.Fragment>
          <Welcome />
          <Box display="flex" justifyContent="space-around" mt={8}>
            <img src="/images/DEPV_Logo.svg" alt="Fachstudio Logo" />
          </Box>
        </React.Fragment>
      )}
    </Wrap>
  );
};

export default observer(Login);
